/**
 * 使用说明：
 */
import React, { PureComponent } from 'react';

import {
    View,
    Image,
    TouchableOpacity,
    StyleSheet,
} from 'react-native'
import {
    JDText
} from '@jdreact/jdreact-core-lib'

import { pt } from '../../common/utils';
import img from '../../common/img';

export default class WifiOut extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let { contentStyle, refresh, middleText, buttonText } = this.props;
        return (
            <View style={[st.wifi_out_wrap, contentStyle]}>
                <Image style={{width: pt(48), height: pt(38)}} source={img.wifi_out}></Image>

                <JDText style={st.error_text}>
                    {middleText || '系统繁忙，获取信息失败'}
                </JDText>

                <TouchableOpacity onPress={refresh} style={st.again}>
                    <JDText style={st.button_text}>
                        {buttonText || '重试'}
                    </JDText>
                    {/* <Image source={img.again}></Image> */}
                </TouchableOpacity>
            </View>
        )
    }
}

const st = StyleSheet.create({
    wifi_out_wrap: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    error_text: {
        color: '#252525',
        marginTop: pt(11),
        fontSize: pt(13)
    },
    again: {
        width: pt(93),
        height: pt(34),
        marginTop: pt(21),
        borderWidth: pt(1),
        borderRadius: pt(17),
        alignItems: 'center',
        borderColor: '#F50800',
        justifyContent: 'center'
    },
    button_text: {
        color: '#252525',
        fontSize: pt(12)
    }
});
